module.exports = __webpack_public_path__ + "img/pdf.ea3e0307.jpeg";